import { rezaEligibleList, useAxiosInstance, usePoQuery } from '@gov-nx/api';

export interface RezaParams {
	role: 'zmocnenec' | 'zmocnitel';
}

export interface RezaParamsMutable extends RezaParams {
	update: (value: RezaParams) => void;
}

export interface RezaFilter {
	text?: string;
	platnostOdOd?: string;
	platnostOdDo?: string;
	platnostDoOd?: string;
	platnostDoDo?: string;
	kodSablony?: string[];
	typ?: 'implicitni' | 'explicitni';
}

interface Props {
	filter: RezaFilter;
	params?: RezaParams;
	enabled?: boolean;
	ignoreError?: boolean;
	isArchivePage?: boolean;
}

export const useRezaEligibleList = ({
	filter,
	params,
	enabled = true,
	ignoreError = true,
	isArchivePage,
}: Props) => {
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery(
		{
			queryKey: [
				'reza',
				isArchivePage ? 'archive-list' : 'list',
				params?.role,
				filter,
			],
			queryFn: async () =>
				rezaEligibleList(axiosInstance, {
					text: filter.text,
					role: params?.role,
					stav: isArchivePage ? 'archivni' : 'platne',
					platnostOdOd: filter.platnostOdOd,
					platnostOdDo: filter.platnostOdDo,
					platnostDoOd: filter.platnostDoOd,
					platnostDoDo: filter.platnostDoDo,
					kodSablony: filter.kodSablony,
					typ: filter.typ,
				}),

			enabled,
		},
		{
			errorIgnoreFilter: () => ignoreError,
		}
	);

	return {
		...query,
		isLoading: query.isLoading,
		isInitialLoading: query.isInitialLoading,
		data: query.data,
	};
};
